const steps = [
  {
    number: "01",
    icon: "ri-gift-2-line",
    title: "Choose Your Gift",
    description: "Browse our curated collection of premium home decor, lifestyle, and gift products.",
    color: "from-[#3a8cbf] to-[#5ab0d4]",
  },
  {
    number: "02",
    icon: "ri-palette-line",
    title: "Customise & Select",
    description: "Personalise your gift or pick from our ready-to-gift options for any occasion.",
    color: "from-[#a8c8e8] to-[#f0a8c8]",
  },
  {
    number: "03",
    icon: "ri-shopping-bag-3-line",
    title: "Purchase Seamlessly",
    description: "Buy via Amazon, WhatsApp, or visit our store — choose what works best for you.",
    color: "from-[#F78FB3] to-[#f5b8cc]",
  },
];

const HowItWorks = () => {
  return (
    <section className="py-20 lg:py-28 bg-white px-6 lg:px-10">
      <div className="max-w-7xl mx-auto">
        {/* Header */}
        <div className="text-center mb-16">
          <span className="text-xs font-semibold tracking-[0.3em] uppercase text-transparent bg-clip-text bg-gradient-to-r from-[#3a8cbf] to-[#e05a8a]">
            Simple Process
          </span>
          <h2 className="text-3xl sm:text-4xl lg:text-5xl font-bold text-gray-900 mt-3 mb-4" style={{ fontFamily: "'Playfair Display', serif" }}>
            How It Works
          </h2>
          <div className="w-16 h-0.5 bg-gradient-to-r from-[#3a8cbf] to-[#e05a8a] mx-auto rounded-full" />
        </div>

        {/* Steps */}
        <div className="relative">
          {/* Connecting line — desktop only */}
          <div className="hidden lg:block absolute top-16 left-[calc(16.6%+40px)] right-[calc(16.6%+40px)] h-0.5 bg-gradient-to-r from-[#5FA8D3] via-[#c8a8d8] to-[#F78FB3] opacity-30" />

          <div className="grid grid-cols-1 md:grid-cols-3 gap-10 lg:gap-8">
            {steps.map((step, idx) => (
              <div key={idx} className="flex flex-col items-center text-center group">
                {/* Circle with icon */}
                <div className="relative mb-8">
                  <div className={`w-28 h-28 lg:w-32 lg:h-32 rounded-full bg-gradient-to-br ${step.color} flex items-center justify-center transition-transform duration-300 group-hover:scale-105`}>
                    <i className={`${step.icon} text-white text-4xl`} />
                  </div>
                  {/* Number badge */}
                  <div className="absolute -top-1 -right-1 w-8 h-8 rounded-full bg-gradient-to-br from-[#3a8cbf] to-[#e05a8a] flex items-center justify-center text-white text-xs font-bold border-2 border-white">
                    {step.number}
                  </div>
                </div>

                <h3 className="text-xl font-bold text-gray-900 mb-3" style={{ fontFamily: "'Playfair Display', serif" }}>
                  {step.title}
                </h3>
                <p className="text-gray-500 text-sm leading-relaxed max-w-xs">
                  {step.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
};

export default HowItWorks;
